import React from 'react';
import { inject, observer } from 'mobx-react';
import  PowerBIEmbedApp  from '../../../common/components/power-bi/power-bi';
import ReferenceDataGridOptions from '../../referencedata/components/reference-data-grid-options';
import {
  faCopy,
  faFileExport,
  faPlus,
  faSave,
  faSync,
  faTrash,
  faEye,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { AppConstants } from '../../../common/APIConstants';

@inject('AuthStore', 'ReferenceDataStore')
@observer
class ReferenceReport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rowSelected: false,
      gridOptions: ReferenceDataGridOptions(),
      newRowNotSaved:false,
      filterModel:null,
      fileNameExcel:null,
      viewProfile: null,
    };
  }

  render() {
    const {
      refreshBtnText
    } = this.props.ReferenceDataStore;
    return (
        <div> <PowerBIEmbedApp path={this.props.path} /> 
        
        <button
                  type="button"
                  className="btn btn-primary btn-grid active"
                  aria-expanded="false"
                  onClick={this.refreshReport}
                >
                  <FontAwesomeIcon icon={faSync} /> {refreshBtnText}

                </button>
        </div>
        );
  }
  refreshReport = async () => {
    const { refreshReportToken } = this.props.AuthStore;
    console.log('token ' + refreshReportToken);
    axios({
      url: 'https://api.powerbi.com/v1.0/myorg/groups/' + AppConstants.APP_REPORT_GROUP_ID + '/datasets/' + AppConstants.APP_REPORT_DATASET_ID + '/refreshes',
      method: 'POST',
      data: {},
      headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
          , Authorization: 'Bearer ' + refreshReportToken
      }
  });

  window.toastr.success("Datasets refreshed successfully. Please check after few minutes.");

  };
}

export default ReferenceReport;
